module.exports = __webpack_public_path__ + "img/album01_06.2f7535bb.jpg";